import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	pageContainer: {
		width: '100%',
		containerType: 'inline-size',
	},
	container: {
		display: 'grid',
		gridTemplateColumns: 'repeat(12, 1fr)',
		gap: THEME.spacing.md,
		paddingBlock: THEME.spacing.lg,
		containerType: 'inline-size',
	},
	filterSection: {
		paddingBlock: THEME.spacing.lg,
	},
	filterHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	exportButton: {
		alignSelf: 'flex-start',
		flexShrink: 0,
	},
	bigDataDisplay: {
		gridColumn: 'span 6',
		'@container (max-width: 800px)': {
			gridColumn: 'span 12 !important',
		},
		'@container (max-width: 600px)': {
			gridColumn: 'span 12 !important',
		},
	},
	chartsSection: {
		display: 'grid',
		gridTemplateColumns: 'repeat(12, 1fr)',
		gap: THEME.spacing.md,
		paddingBlock: THEME.spacing.lg,
		containerType: 'inline-size',
		...CssSelectors.allDescendants({
			outline: 'none',
		}),
		'& > *': {
			gridColumn: 'span 6',
		},
		'@container (max-width: 1200px)': {
			'& > *': {
				gridColumn: 'span 6',
			},
		},
		'@container (max-width: 768px)': {
			gridTemplateColumns: 'repeat(6, 1fr)',
			gap: THEME.spacing.sm,
			'& > *': {
				gridColumn: 'span 6',
			},
		},
		'@container (max-width: 480px)': {
			gridTemplateColumns: 'repeat(4, 1fr)',
			gap: THEME.spacing.xs,
			'& > *': {
				gridColumn: 'span 4',
			},
		},
	},
	tableSection: {
		paddingBlock: THEME.spacing.lg,
	},
});
